import api from "../libs/api";

export default {
	getServices: (page = 1, itemsPerPage = 15) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/services`, {
					params: {
						page: page,
						per_page: itemsPerPage,
					},
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getServiceUP: async (page = 1, itemsPerPage = 15, searchQuery) => {
		try {
			const { status, data } = await api().get(`/services`, {
				params: { page, per_page: itemsPerPage, search: searchQuery },
			});
			if (status === 200) return data;
			throw new Error(`Failed with status: ${status}`, status);
		} catch (error) {
			throw error; // Re-throw to handle at a higher level if needed
		}
	},

	getTeams: (page = 1, itemsPerPage = 15) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/get-all-teams`, {
					// params: {
					//   page: page,
					//   per_page: itemsPerPage,
					// },
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getAllServices: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/services?all=true`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	postService: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post("/services", data)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateService: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`/services/${id}`, data)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteService: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/services/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},
};
